import { render, staticRenderFns } from "./ClientsInfo.vue?vue&type=template&id=aebf0f34"
import script from "./ClientsInfo.vue?vue&type=script&lang=js"
export * from "./ClientsInfo.vue?vue&type=script&lang=js"
import style0 from "./ClientsInfo.vue?vue&type=style&index=0&id=aebf0f34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports